import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import {FormBuilder, FormGroup, FormsModule, Validators, FormControl} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { format } from 'date-fns';
import { Factura } from '../../../models/factura';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-changeToCashOut',
  styleUrls: [],
  templateUrl: 'fecha-pago.component.html',
  providers: [generalService]
})


export class modalFechaPagoFactura implements OnInit{
  constructor(public dataService: DataService,
              private dialogRef: MatDialogRef<modalFechaPagoFactura>, 
              @Inject(MAT_DIALOG_DATA) data,
              public _generalService: generalService,
              private formBuilder: FormBuilder,
             public dialog: MatDialog,
               private route: ActivatedRoute
              ) {
  }
 
  
  public factura: Factura = null;
  form:FormGroup;
  btnguarda = false;
  dateInput = true;
  dateTxt =true;
  fechaFormateada:any;
  
    ngOnInit() {  
        this.form = this.formBuilder.group({
            fechaPagoFactura:  ""
        }); 
        this.consultarFechaPagoFactura();
    }

    cerrarModal() {
        this.dataService.dialogRef.close();
    }
  

    guardarFechaPagoFactura(){
        let metodo = 'factura/guardarFechaPagoFactura';
        let fecha = this.form.controls['fechaPagoFactura'].value;
       

        const params = {
            BILL_ID: this.dataService.dialogRef._containerInstance._config.data.BILL_ID,
            PAYMENT_DATE: fecha  
        };
        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                this.cerrarModal();
                this._generalService.toastCall("Fecha de pago guardada exitosamente.") 
           
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
            
        );
        
    }
    consultarFechaPagoFactura(){
        let metodo = 'factura/ConsultarFechaPagoFactura';
        const params = {
            BILL_ID: this.dataService.dialogRef._containerInstance._config.data.BILL_ID,
        };
        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                if (result.includes("null")) {
                    
                    this.dateInput = true;
                    this.dateTxt= false
                    
                } else{
                    this.dateTxt= true
                    this.dateInput = false;
                }
                
                // Formato de Fecha YYYY-MM-DD
                let fechaSeparada = JSON.parse(result)[0].PAYMENT_DATE.split('T');
                this.form.controls['fechaPagoFactura'].setValue(fechaSeparada[0]);
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }
    
}


// WEBPACK FOOTER //
// ./src/app/factura/consultar-eliminar/fechaPago/fecha-pago.component.ts